module.exports = {"130929100":"乐寿镇","130929101":"淮镇镇","130929102":"郭庄镇","130929103":"河城街镇","130929104":"韩村镇","130929105":"陌南镇","130929106":"陈庄镇","130929205":"徐留高乡","130929206":"商林乡","130929207":"段村乡","130929209":"张村乡","130929210":"临河乡","130929211":"小平王乡","130929212":"十五级乡","130929213":"垒头乡","130929214":"南河头乡","130929215":"西城乡","130929216":"本斋回族乡","130929400":"农场","130929401":"献县经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130929.json
// module id = 200
// module chunks = 0